import { isNavigationFailure, NavigationFailureType } from "vue-router";

export function postLoginRoute(roles) {
  return { name: Array.isArray(roles) && roles.includes("admin") ? "dashboard" : "repairs" };
}

export function navigateAfterLogin(router, roles) {
  return router.replace(postLoginRoute(roles)).catch(error => {
    if (
      isNavigationFailure(error, NavigationFailureType.redirected) ||
      isNavigationFailure(error, NavigationFailureType.duplicated)
    ) {
      return;
    }
    throw error;
  });
}
